// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"f7f87b61","662":"f7f87b61"}[chunkId] + ".chunk.css";
};